import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen" data-id="element-153" data-mp="zww0z6ntnv30">
      <Header data-id="element-154" data-mp="uyksaz99jqmd" />
      <main className="flex-grow pt-[104px] lg:pt-[116px]" data-id="element-155" data-mp="uy1i64puu6iw">{children}</main>
      <Footer data-id="element-156" data-mp="78gz7ltpb99m" />
      <WhatsAppButton data-id="element-157" data-mp="78781uwx6w2c" />
    </div>;
}